import { Sprite } from "./Sprite";
import { LEVEL_ONE_PATH } from "../constants/constants";
import Position from "../types/PositionType";
import { Canvas } from "./Canvas";
import slime from "../static/Enemies/SlimeRedx2.png";
import { scalePositionToResolution } from "helpers/mathFunctions";

export class Enemy extends Sprite {
  private _health: number = 100;
  private _pathingIndex: number = 1;
  private _placementCorretion: number = 10;
  private _movementMultiplayer: number;

  constructor(
    canvas: Canvas,
    position: Position,
    movementMultiplayer: number = 1
  ) {
    super(
      position,
      slime,
      canvas,
      {
        maxX: 4,
        maxY: 4,
      },
      30,
      30
    );
    this._movementMultiplayer = movementMultiplayer;
  }

  public draw() {
    super.draw();

    // Health bar
    const healthBarWidth = this.width * (this._health / 100);
    this.canvas.drawRect(
      this.position.x + this._placementCorretion,
      this.position.y,
      this.width,
      5,
      "red"
    );
    this.canvas.drawRect(
      this.position.x + this._placementCorretion,
      this.position.y,
      healthBarWidth,
      5,
      "green"
    );
  }

  public updatePosition() {
    this.draw();
    if (!this.canvas.paused) {
      // Position calculation based on the Tiled map layout
      const path = scalePositionToResolution(
        LEVEL_ONE_PATH[this._pathingIndex],
        this.canvas.width
      );
      const distanceX = path.x - this.center.x;
      const distanceY = path.y - this.center.y;
      const angle = Math.atan2(distanceY, distanceX);
      this.position.x += Math.cos(angle) * this.movementMultiplayer;
      this.position.y += Math.sin(angle) * this.movementMultiplayer;
      this.center = {
        x: this.position.x + this.width / 2,
        y: this.position.y + this.height / 2,
      };
      if (
        Math.abs(Math.round(this.center.x) - path.x) <
          this.movementMultiplayer &&
        Math.abs(Math.round(this.center.y) - path.y) <
          this.movementMultiplayer &&
        LEVEL_ONE_PATH.length - 1 > this._pathingIndex
      ) {
        this._pathingIndex++;
      }
    }
  }

  public get health(): number {
    return this._health;
  }

  public set health(health: number) {
    this._health = health;
  }

  public get movementMultiplayer(): number {
    return this._movementMultiplayer;
  }

  public set movementMultiplayer(movementMultiplayer: number) {
    this._movementMultiplayer = movementMultiplayer;
  }

  public get pathingIndex(): number {
    return this._pathingIndex;
  }

  public set pathingIndex(pathingIndex: number) {
    this._pathingIndex = pathingIndex;
  }
}
